module.exports = __webpack_public_path__ + "static/media/u35_premium_contract3.67c5e8a9.webp";